var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "48px",
        height: "48px",
        viewBox: "0 0 48 48",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Final",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Summer----Active",
                transform: "translate(1.000000, 1.000000)",
                stroke: "#000000",
                "stroke-width": "2"
              }
            },
            [
              _c("circle", {
                attrs: { id: "Oval", cx: "23", cy: "23.002", r: "8" }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "23",
                  y1: "0.002",
                  x2: "23",
                  y2: "8.002",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "23",
                  y1: "38.002",
                  x2: "23",
                  y2: "46.002",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "6.736",
                  y1: "6.738",
                  x2: "12.394",
                  y2: "12.394",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "33.606",
                  y1: "33.608",
                  x2: "39.264",
                  y2: "39.266",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "0",
                  y1: "23.002",
                  x2: "8",
                  y2: "23.002",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "38",
                  y1: "23.002",
                  x2: "46",
                  y2: "23.002",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "6.736",
                  y1: "39.266",
                  x2: "12.394",
                  y2: "33.608",
                  id: "Path"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  x1: "33.606",
                  y1: "12.394",
                  x2: "39.264",
                  y2: "6.738",
                  id: "Path"
                }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79995863", { render: render, staticRenderFns: staticRenderFns })
  }
}